<script lang="ts">
  /**
   * The "top N of M" notice, one line per truncated exposure kind of a provider.
   *
   * The publisher ranks by finding count and caps each provider's rows per exposure kind, so a
   * capped kind is showing the worst rows, not all of them. Saying so on screen is the only way
   * a reviewer can tell the difference between "this is everything" and "this is the top slice".
   */
  import { providerLabel, truncationNotice, type ExposedDocumentsProviderMetadata } from "../exposedSensitiveDocuments";

  let { metadata }: { metadata: ExposedDocumentsProviderMetadata[] } = $props();

  const notices = $derived(
    metadata.flatMap((meta) =>
      truncationNotice(meta).map((notice) => ({
        key: `${meta.id}:${notice.kind}`,
        provider: providerLabel(meta.provider ?? meta.id),
        notice,
      })),
    ),
  );
</script>

{#each notices as entry (entry.key)}
  <div
    class="rounded-lg border border-blue-200 bg-blue-50 px-3 py-2 text-xs text-blue-900"
    data-testid="exposure-truncation-notice"
  >
    <span class="font-semibold">{entry.provider} · {entry.notice.kindLabel}</span>
    · showing the {entry.notice.label} qualifying documents, ranked by instance count. The rest were not published.
  </div>
{/each}
